import React, { useEffect, useRef } from 'react';
import BEMHelper from '@ynap/bem-helper';
import { Link } from '@ynap/router';

const bem = new BEMHelper('ProductInformation');

const renderDesignerInfo = ({
    designerName,
    name,
    isLoading,
    designerModifier,
    nameModifier,
    promoPriceApplied,
    selectedProductBadgeModifier,
    soldOut,
    accordionContentRef,
}) => (
    <h1 ref={accordionContentRef} className={bem('designerInfoContainer')}>
        <span className={bem('designer', [isLoading, designerModifier, soldOut ? 'soldOut' : ''])}>{designerName}</span>
        <span className={bem('name', [isLoading, nameModifier, promoPriceApplied, selectedProductBadgeModifier, soldOut ? 'soldOut' : ''])}>{name}</span>
    </h1>
);

type ProductInformationProps = {
    className?: {
        container?: string;
        designerModifier?: string;
        nameModifier?: string;
        selectedProductBadgeModifier?: string;
        soldOut?: string;
    };
    designerLinkOnClick?: (...args: unknown[]) => void;
    designerName: string;
    designerSeo: {
        seoURLKeyword: string;
    };
    generateListingUrl: (plpUrlTemplate: string, options: { LOCALE: string; SEO_URLKEYWORD: string }) => string;
    loading: boolean;
    locale: string;
    name: string;
    plpUrlTemplate: string;
    productId: string;
    promoPriceApplied: string;
    selectedProductBadgeModifier: string;
    setWidth: (width: number) => void;
    skuId: string;
};

const ProductInformation = (props: ProductInformationProps) => {
    const {
        name,
        designerName,
        designerSeo,
        productId,
        skuId,
        className = {},
        generateListingUrl,
        plpUrlTemplate,
        locale,
        loading,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        designerLinkOnClick = () => {},
        promoPriceApplied,
        setWidth,
    } = props;
    const isLoading = loading ? 'loading' : null;

    const { container = '', designerModifier = null, nameModifier = null, selectedProductBadgeModifier = null, soldOut = null } = className;
    const accordionContentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const carouselWidthCalculation = accordionContentRef?.current?.offsetWidth;
        carouselWidthCalculation && setWidth?.(carouselWidthCalculation);
    }, [accordionContentRef]);

    return (
        <div className={bem(undefined, undefined, container)}>
            {designerSeo ? (
                <Link
                    to={generateListingUrl(plpUrlTemplate, {
                        LOCALE: locale,
                        SEO_URLKEYWORD: designerSeo.seoURLKeyword,
                    })}
                    onClick={designerLinkOnClick}
                >
                    {renderDesignerInfo({
                        designerName,
                        name,
                        isLoading,
                        designerModifier,
                        nameModifier,
                        promoPriceApplied,
                        selectedProductBadgeModifier,
                        soldOut,
                        accordionContentRef,
                    })}
                </Link>
            ) : (
                renderDesignerInfo({
                    designerName,
                    name,
                    isLoading,
                    designerModifier,
                    nameModifier,
                    promoPriceApplied,
                    selectedProductBadgeModifier,
                    soldOut,
                    accordionContentRef,
                })
            )}

            {/* product/sku info for personal shopper chrome extension */}
            <meta itemProp="productID" content={productId} />
            <meta itemProp="sku" content={skuId} />
        </div>
    );
};

export default ProductInformation;
